import React from 'react';
import { Badge } from 'reactstrap';
import classNames from 'classnames';

const BF_SALE = window.BF2019_SALE;


const priceValue = (price, strikedPrice) => {
  const _price = Math.floor(price)
  const _cents = (price - _price) * 100
  
  return <span className={classNames({"price-value": true, 'text-danger': BF_SALE && strikedPrice > 0})}>
    {strikedPrice > 0 && <span className="striked-price">${strikedPrice}</span>}
    ${_price}
    {_cents > 0 && <sup className="price-cents">{_cents}</sup>}
    <sub className="period-sub">/mo</sub>
  </span>
}

const PlanPrice = ({price, annual_price, annual}) => {
  const _price = Math.round((annual ? annual_price / 12 : price) * 100 ) / 100;
  const _strikedPrice = annual && price
  
  
  return (
    <div className="pricing-plan-price" style={{width: '100%'}}>

      {BF_SALE && <Badge color="secondary" style={{background: '#000', margin: '1rem', marginBottom: '0.5rem', padding: '0.5rem 1rem', display: 'block'}}>BLACK FRIDAY</Badge>}
      
      <div className="plan-price">
        {priceValue(_price, _strikedPrice)}
      </div>
      <div className="small gray">
        <span>
          billed {annual ? 'annually' : 'monthly'}
          <br />{annual ? 'with' : 'without'} ${(price * 12) - annual_price } discount
        </span>
      </div>
    </div>
)}

export default PlanPrice;


// WEBPACK FOOTER //
// ./src/components/billing/PlanPrice.js